export const GET_USERS = 'GET_USERS';
export const USERS_ERROR = 'USERS_ERROR';
export const GET_USERS_LOADING = 'GET_USERS_LOADING'


export const GET_USERS_FAQ = 'GET_USERS_FAQ';
export const USERS_FAQ_ERROR = 'USERS_FAQ_ERROR';

export const GET_DRIVERS_VALID = 'GET_DRIVERS_VALID';
export const DRIVERS_VALID_ERROR = 'DRIVERS_VALID_ERROR';

export const GET_DRIVERS_BANNED = 'GET_DRIVERS_BANNED';
export const DRIVERS_BANNED_ERROR = 'DRIVERS_BANNED_ERROR';

export const GET_DRIVERS_NEW = 'GET_DRIVERS_NEW';
export const DRIVERS_NEW_ERROR = 'DRIVERS_NEW_ERROR';

export const GET_DRIVERS_FAQ = 'GET_DRIVERS_FAQ';
export const DRIVERS_FAQ_ERROR = 'DRIVERS_FAQ_ERROR';

export const GET_DROPPOINTS = 'GET_DROPPOINTS';
export const DROPPOINTS_ERROR = 'DROPPOINTS_ERROR';

export const GET_BOOKINGS = 'GET_BOOKINGS';
export const BOOKINGS_ERROR = 'BOOKINGS_ERROR';

export const GET_BOOKINGS_CANCELLATION = 'GET_BOOKINGS_CANCELLATION';
export const BOOKINGS_CANCELLATION_ERROR = 'BOOKINGS_CANCELLATION_ERROR';

export const GET_BOOKINGS_REQUESTS_WAITING = "GET_BOOKINGS_REQUESTS_WAITING"
export const BOOKINGS_REQUESTS_WAITING_LOADING = "BOOKINGS_REQUESTS_WAITING_LOADING"
export const GET_BOOKINGS_REQUESTS_WAITING_ERROR = "GET_BOOKINGS_REQUESTS_WAITING_ERROR"

export const GET_BOOKINGS_REQUESTS_CONFIRMED = "GET_BOOKINGS_REQUESTS_CONFIRMED"
export const BOOKINGS_REQUESTS_CONFIRMED_LOADING = "BOOKINGS_REQUESTS_CONFIRMED_LOADING"
export const GET_BOOKINGS_REQUESTS_CONFIRMED_ERROR = "GET_BOOKINGS_REQUESTS_CONFIRMED_ERROR"

export const GET_BOOKINGS_REQUESTS_CANCELLED = "GET_BOOKINGS_REQUESTS_CANCELLED"
export const BOOKINGS_REQUESTS_CANCELLED_LOADING = "BOOKINGS_REQUESTS_CANCELLED_LOADING"
export const GET_BOOKINGS_REQUESTS_CANCELLED_ERROR = "GET_BOOKINGS_REQUESTS_CANCELLED_ERROR"

export const PATCH_CONFIRM_BOOKING_REQUEST="PATCH_CONFIRM_BOOKING_REQUEST";
export const PATCH_CANCEL_BOOKING_REQUEST="PATCH_CANCEL_BOOKING_REQUEST";


export const GET_TRIP = 'GET_TRIP';
export const TRIP_ERROR = 'TRIP_ERROR';


export const GET_TRIP_CANCELLATION = 'GET_TRIP_CANCELLATION';
export const TRIP_CANCELLATION_ERROR = 'TRIP_CANCELLATION_ERROR';

export const GET_TIMESLOT = 'GET_TIMESLOT';
export const TIMESLOT_ERROR = 'TIMESLOT_ERROR';

export const LINE_LOADING='LINE_LOADING';
export const GET_LINE = 'GET_LINE';
export const LINE_ERROR = 'LINE_ERROR';
export const POST_LINE= "POST_LINE"

export const LINES_REQUESTS_LOADING="GET_LINES_REQUESTS_LOADING"
export const GET_LINES_REQUESTS_ERROR="GET_LINES_REQUESTS_ERROR"
export const GET_LINES_REQUESTS="GET_LINES_REQUESTS"
 
export const GET_PAYEMENT = 'GET_PAYEMENT';
export const PAYEMENT_ERROR = 'PAYEMENT_ERROR';

// Coupons
export const COUPON_LOADING = 'COUPON_LOADING'
export const GET_COUPON = 'GET_COUPON';
export const COUPON_ERROR = 'COUPON_ERROR';
export const POST_COUPON = 'POST_COUPON'
export const PATCH_COUPON='PATCH_COUPON'
export const DELETE_COUPON = 'DELETE_COUPON'


// user authorities
export const AUTHORITIES_ERROR = 'AUTHORITIES_ERROR';
export const GET_AUTHORITIES = 'GET_AUTHORITIES';

// the dashboard users
export const GET_DASHBOARD_USERS = "GET_DASHBOARD_USERS";
export const DASHBOARD_USERS_ERROR = "DASHBOARD_USERS_ERROR";
export const GET_DASHBOARD_LOADING = "GET_DASHBOARD_LOADING";

export const  DASHBOARD_ADD_USERS ="DASHBOARD_ADD_USERS";
export const DASHBOARD_ADD_USERS_ERROR="DASHBOARD_ADD_USERS_ERROR"

export const DASHBOARD_ACTIVATE_USER = "DASHBOARD_ACTIVATE_USER"
export const DASHBOARD_DEACTIVATE_USER="DASHBOARD_DEACTIVATE_USER"
export const DASHBOARD_DEACTIVATE_ACTIVATE_USER_ERROR = "DASHBOARD_DEACTIVATE_ACTIVATE_USER_ERROR"

export const DASHBOARD_UPDATE_USER_AUTHORITIES="DASHBAORD_UPDATE_USER_AUTHORITIES";
export const DASHBOARD_UPDATE_USER_AUTHORITIES_ERROR="DASHBAORD_UPDATE_USER_AUTHORITIES_ERROR";

export const DASHBOARD_ADD_NEW_AUTHORITY_USER_DASHBAORD ="DASHBOARD_ADD_NEW_AUTHORITY_USER_DASHBAORD"

// LOGIN
export const LOGIN_DASHBOARD_USER="LOGIN_DASHBOARD_USER";

// APPROVE DRIVER
export const APPROVE_DRIVER_LOADING="APPROVE_DRIVER_LOADING"
export const APPROVE_DRIVER='APPROVE_DRIVER';
export const APPROVE_DRIVER_ERROR='APPROVE_DRIVER_ERROR';

// STATS LANDING PAGE

export const GET_STATS_LANDING = 'GET_STATS_LANDING'
export const GET_STATS_LANDING_LOADING = 'GET_STATS_LANDING_LOADING'
export const GET_STATS_LANDING_ERROR = 'GET_STATS_LANDING_ERROR'

// Driver History

export const GET_DRIVER_TRIPS_COMPLETED="GET_DRIVER_TRIPS_COMPLETED"
export const GET_DRIVER_TRIPS_IN_PROGRESS="GET_DRIVER_TRIPS_IN_PROGRESS"
export const GET_DRIVER_TRIPS_DECLINED="GET_DRIVER_TRIPS_DECLINED"
export const GET_DRIVER_TRIPS_COMPLETED_LOADING="GET_DRIVER_TRIPS_COMPLETED_LOADING"
export const GET_DRIVER_TRIPS_IN_PROGRESS_LOADING="GET_DRIVER_TRIPS_IN_PROGRESS_LOADING"
export const GET_DRIVER_TRIPS_DECLINED_LOADING="GET_DRIVER_TRIPS_DECLINED_LOADING"
export const GET_DRIVER_TRIPS_COMPLETED_ERROR="GET_DRIVER_TRIPS_COMPLETED_ERROR"
export const GET_DRIVER_TRIPS_IN_PROGRESS_ERROR="GET_DRIVER_TRIPS_IN_PROGRESS_ERROR"
export const GET_DRIVER_TRIPS_DECLINED_ERROR="GET_DRIVER_TRIPS_DECLINED_ERROR"

export const SET_SNACKBAR_CONTENT="SET_SNACKBAR_CONTENT"
export const CLOSE_SNACKBAR="CLOSE_SNACKBAR"

export const OPERATIONAL_DRIVERS_LOADING='OPERATIONAL_DRIVERS_LOADING';
export const OPERATIONAL_DRIVERS_ERROR='OPERATIONAL_DRIVERS_ERROR';
export const GET_OPERATIONAL_DRIVERS='GET_OPERATIONAL_DRIVERS';
export const POST_OPERATIONAL_DRIVERS='POST_OPERATIONAL_DRIVERS';

export const SMS_GATEWAY_LOADING='SMS_GATEWAY_LOADING';
export const SMS_GATEWAY_ERROR='SMS_GATEWAY_ERROR';
export const GET_SMS_GATEWAY='GET_SMS_GATEWAY';
export const POST_SMS_GATEWAY='POST_SMS_GATEWAY';






 